// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const DEFINE_TEMPLATE_VARIABLES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.DEFINE_TEMPLATE_VARIABLES,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      Dataset: {
        systemName: 'Dataset',
        displayName: 'Variables dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      variables: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            name: {
              kind: 'string',
              required: true
            },
            definition: {
              kind: 'taggedUnion',
              required: true,
              tagKey: 'kind',
              choices: [
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    kind: {
                      kind: 'string',
                      required: true,
                      value: 'array'
                    },
                    elementSpec: {
                      kind: 'taggedUnion',
                      required: true,
                      tagKey: 'kind',
                      choices: [
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            kind: {
                              kind: 'string',
                              required: true,
                              value: 'boolean'
                            },
                            required: {
                              kind: 'boolean',
                              required: true
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            kind: {
                              kind: 'string',
                              required: true,
                              value: 'number'
                            },
                            required: {
                              kind: 'boolean',
                              required: true
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            kind: {
                              kind: 'string',
                              required: true,
                              value: 'integer'
                            },
                            minValue: {
                              kind: 'integer',
                              required: false
                            },
                            maxValue: {
                              kind: 'integer',
                              required: false
                            },
                            required: {
                              kind: 'boolean',
                              required: true
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            kind: {
                              kind: 'string',
                              required: true,
                              value: 'string'
                            },
                            required: {
                              kind: 'boolean',
                              required: true
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            kind: {
                              kind: 'string',
                              required: true,
                              value: 'domain'
                            },
                            types: {
                              kind: 'array',
                              required: true,
                              elementSpec: {
                                kind: 'enum',
                                required: true,
                                choices: [
                                  'PLATE',
                                  'CUSTOM_ENTITY',
                                  'AA_SEQUENCE',
                                  'DNA_SEQUENCE',
                                  'RNA_SEQUENCE',
                                  'MIXTURE',
                                  'MOLECULE',
                                  'USER'
                                ]
                              },
                              minItems: 1,
                              maxItems: 1
                            },
                            required: {
                              kind: 'boolean',
                              required: true
                            }
                          }
                        }
                      ]
                    },
                    required: {
                      kind: 'boolean',
                      required: true
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    kind: {
                      kind: 'string',
                      required: true,
                      value: 'boolean'
                    },
                    required: {
                      kind: 'boolean',
                      required: true
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    kind: {
                      kind: 'string',
                      required: true,
                      value: 'number'
                    },
                    required: {
                      kind: 'boolean',
                      required: true
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    kind: {
                      kind: 'string',
                      required: true,
                      value: 'integer'
                    },
                    minValue: {
                      kind: 'integer',
                      required: false
                    },
                    maxValue: {
                      kind: 'integer',
                      required: false
                    },
                    required: {
                      kind: 'boolean',
                      required: true
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    kind: {
                      kind: 'string',
                      required: true,
                      value: 'string'
                    },
                    required: {
                      kind: 'boolean',
                      required: true
                    }
                  }
                },
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    kind: {
                      kind: 'string',
                      required: true,
                      value: 'domain'
                    },
                    types: {
                      kind: 'array',
                      required: true,
                      elementSpec: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'PLATE',
                          'CUSTOM_ENTITY',
                          'AA_SEQUENCE',
                          'DNA_SEQUENCE',
                          'RNA_SEQUENCE',
                          'MIXTURE',
                          'MOLECULE',
                          'USER'
                        ]
                      },
                      minItems: 1,
                      maxItems: 1
                    },
                    required: {
                      kind: 'boolean',
                      required: true
                    }
                  }
                }
              ]
            },
            value: {
              kind: 'anything',
              required: true
            }
          }
        },
        minItems: 1,
        maxItems: 100
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
